"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const openapi_1 = require("../../../openapi");
const Registry = __importStar(require("../device/registry/schema"));
const MetadataSchema = __importStar(require("../metadata/schema"));
const spec_1 = require("../metadata/spec");
const Notification = __importStar(require("../notification/schema"));
const UserSchema = __importStar(require("../user/schema"));
const spec_2 = require("../user/spec");
const Greg = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Greg.Spec';
/*
 * Mirrors AdminOrDealerUserRouteGuard via v1Roles (v1 `{ message }` failure
 * bodies). Security.AdminOrDealerUser documents unreachable v2 error.type
 * variants and must not be used on v1 Express routes.
 */
const withGregGuard = openapi_1.Security.v1Roles(...openapi_1.Security.GuardRoles.AdminUser, ...openapi_1.Security.GuardRoles.DealerUser);
/*
 * Mirrors reg-bff RETIRED and the legacy JSDoc `deprecated`/`x-retirement` on
 * these Express handlers. Until cutover Express still serves them; after REG
 * traffic moves to the BFF they answer 410 Gone. Do not addError(Gone) yet —
 * unified-api does not return 410 today.
 */
const RETIREMENT_NOTE = 'Scheduled for retirement. Once REG traffic is routed to the REG BFF this operation answers 410 Gone and stops returning data. Until cutover, the other responses describe what Express still serves.';
const withActive = (endpoint) => endpoint.pipe(withGregGuard, openapi_1.Error.withV1StandardErrors);
const withRetirement = (endpoint) => endpoint.pipe(openapi_1.Annotations.deprecated(), openapi_1.Annotations.appendDescription(RETIREMENT_NOTE), withGregGuard, openapi_1.Error.withV1StandardErrors);
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful GREG mutation',
});
const AccountEmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful user-account mutation',
});
const MetadataItemsResponse = openapi_1.Response.Success(MetadataSchema.Items).annotations({
    description: 'Stored device metadata',
});
const DeviceItemResponse = openapi_1.Response.Success(Greg.DeviceItem).annotations({
    description: 'GREG device registry record',
});
const DevicePageResponse = openapi_1.Response.Success(Greg.DevicePage).annotations({
    description: 'Paginated GREG device registry records',
});
const LatestDataResponse = openapi_1.Response.Success(Greg.LatestData).annotations({
    description: 'Latest device datapoints with optional owner profile',
});
const ChannelListResponse = openapi_1.Response.Success(Notification.ChannelList).annotations({
    description: 'Notification channels',
});
const ChannelCreateResponse = openapi_1.Response.Success(Notification.ChannelCreateResult).annotations({
    description: 'Created notification channel; data is empty today',
});
const ChannelUpdateResponse = openapi_1.Response.Success(Notification.ChannelUpsertResult).annotations({
    description: 'Updated notification channel',
});
const NotificationListResponse = openapi_1.Response.Success(Notification.NotificationList).annotations({
    description: 'Notification rules',
});
const LegacyModelValidation = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.LegacyModelValidation`, 'INVALID_REQUEST', 'Validation Error (Legacy Model Format)', 'The legacy JSON-schema model rejected the query. Carries no express-validator field errors.', { validation: effect_1.Schema.Array(Json.Record) });
// Query structs intentionally have no identifier (see device/shared.ts).
const UserIdQuery = effect_1.Schema.Struct({
    userId: effect_1.Schema.NonEmptyString,
});
const updateAccount = platform_1.HttpApiEndpoint.put('updateAccount') `/user/account`
    .setPayload(UserSchema.UpdateAccountPayload)
    .addSuccess(AccountEmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(spec_2.MutationRejected)
    .addError(spec_2.MutationForbidden)
    .annotate(platform_1.OpenApi.Title, 'Replace User Account (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Same as PUT /admin/user/account: replaces the user profile. Omitted optional fields are cleared to null; omitted firstName, lastName and country are kept.')
    .pipe(withRetirement);
const patchAccount = platform_1.HttpApiEndpoint.patch('patchAccount') `/user/account`
    .setPayload(UserSchema.UpdateAccountPayload)
    .addSuccess(AccountEmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(spec_2.MutationRejected)
    .addError(spec_2.MutationForbidden)
    .annotate(platform_1.OpenApi.Title, 'Patch User Account (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Same as PATCH /admin/user/account: updates only the supplied fields; omitted fields are kept.')
    .pipe(withRetirement);
const getRegistry = platform_1.HttpApiEndpoint.get('getRegistry') `/device/registry`
    .setUrlParams(Greg.GetDeviceQuery)
    .addSuccess(DeviceItemResponse)
    .annotate(platform_1.OpenApi.Title, 'Get Device (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Returns one device in the GREG projection (owner profile, unit type/alerts/errors). A missing or invisible serial still answers 200 with no item.')
    .pipe(withActive);
const deleteRegistry = platform_1.HttpApiEndpoint.del('deleteRegistry') `/device/registry`
    .setPayload(Registry.DeviceIdentity)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Deregister Device (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Same as DELETE /admin/device/registry: deregisters a device. An unknown serial currently answers 500.')
    .pipe(withActive);
const listRegistry = platform_1.HttpApiEndpoint.get('listRegistry') `/device/registry/list`
    .setUrlParams(Greg.ListDevicesQuery)
    .addSuccess(DevicePageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Devices (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Lists devices with GREG filters (bracket query keys such as filters[accountNumber], page[current]/page[size]) and the GREG record projection. Top-level serialNumber/name/model/ownerId/dealerId are length-checked when present but do not filter the result set.')
    .pipe(withActive);
const getLatestData = platform_1.HttpApiEndpoint.get('getLatestData') `/device/data`
    .setUrlParams(Greg.GetDeviceQuery)
    .addSuccess(LatestDataResponse)
    .addError(LegacyModelValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get Latest Device Data (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Latest telemetry/state datapoints plus optional customerInformation when the device has an owner. A missing device answers 404.')
    .pipe(withActive);
const getDeviceMetadata = platform_1.HttpApiEndpoint.get('getDeviceMetadata') `/metadata/device`
    .setUrlParams(MetadataSchema.DeviceQuery)
    .addSuccess(MetadataItemsResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Device Metadata (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Same as GET /admin/metadata/device. Lookup is by id; manufacturingSerialNumber-only queries return items {}.')
    .pipe(withActive);
const addDeviceMetadata = platform_1.HttpApiEndpoint.post('addDeviceMetadata') `/metadata/device`
    .setPayload(MetadataSchema.DeviceUpsertPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(spec_1.UnknownOwner)
    .annotate(platform_1.OpenApi.Title, 'Add Device Metadata (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Same as POST /admin/metadata/device. A missing device is a second 422 shape that carries only INVALID_REQUEST.')
    .pipe(withRetirement);
const removeDeviceMetadata = platform_1.HttpApiEndpoint.del('removeDeviceMetadata') `/metadata/device`
    .setPayload(MetadataSchema.DeviceRemovalPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(spec_1.UnknownOwner)
    .annotate(platform_1.OpenApi.Title, 'Remove Device Metadata (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Same as DELETE /admin/metadata/device. A missing device is a second 422 shape that carries only INVALID_REQUEST.')
    .pipe(withRetirement);
const listChannels = platform_1.HttpApiEndpoint.get('listChannels') `/notifications/channels`
    .setUrlParams(UserIdQuery)
    .addSuccess(ChannelListResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Notification Channels (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Lists all notification channels for a user.')
    .pipe(withRetirement);
const deleteChannel = platform_1.HttpApiEndpoint.del('deleteChannel') `/notifications/channels`
    .setPayload(Greg.ChannelDeletePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete Notification Channel (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Deletes a notification channel by channelId. Unlike admin, the GREG wrapper requires userId.')
    .pipe(withRetirement);
const createMobileChannel = platform_1.HttpApiEndpoint.post('createMobileChannel') `/notifications/channel/mobile`
    .setPayload(Notification.MobileChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Mobile Notification Channel (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Creates an active mobile push channel for a user and app. The answer does not carry the id of the new channel: data is empty, so read the id from GET /notifications/channels.')
    .pipe(withRetirement);
const updateMobileChannel = platform_1.HttpApiEndpoint.put('updateMobileChannel') `/notifications/channel/mobile`
    .setPayload(Notification.MobileChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update Mobile Notification Channel (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Replaces a mobile push channel and keeps it active. Returns 401 when payload userId/appId do not match the channel owner.')
    .pipe(withRetirement);
const createEmailChannel = platform_1.HttpApiEndpoint.post('createEmailChannel') `/notifications/channel/email`
    .setPayload(Notification.EmailChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Email Notification Channel (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Creates an active email channel for a user and app. The answer does not carry the id of the new channel: data is empty, so read the id from GET /notifications/channels.')
    .pipe(withRetirement);
const updateEmailChannel = platform_1.HttpApiEndpoint.put('updateEmailChannel') `/notifications/channel/email`
    .setPayload(Notification.EmailChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update Email Notification Channel (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Replaces an email channel and keeps it active. Returns 401 when payload userId/appId do not match the channel owner.')
    .pipe(withRetirement);
const createSmsChannel = platform_1.HttpApiEndpoint.post('createSmsChannel') `/notifications/channel/sms`
    .setPayload(Notification.SmsChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create SMS Notification Channel (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Creates an active SMS channel for a user and app. The answer does not carry the id of the new channel: data is empty, so read the id from GET /notifications/channels.')
    .pipe(withRetirement);
const updateSmsChannel = platform_1.HttpApiEndpoint.put('updateSmsChannel') `/notifications/channel/sms`
    .setPayload(Notification.SmsChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update SMS Notification Channel (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Replaces an SMS channel and keeps it active. Returns 401 when payload userId/appId do not match the channel owner.')
    .pipe(withRetirement);
const listNotifications = platform_1.HttpApiEndpoint.get('listNotifications') `/notifications`
    .setUrlParams(UserIdQuery)
    .addSuccess(NotificationListResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Notifications (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Lists notification rules for a user. Stored id is returned as both ruleId and notificationId.')
    .pipe(withActive);
const createNotification = platform_1.HttpApiEndpoint.post('createNotification') `/notifications`
    .setPayload(Notification.NotificationCreatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Notification (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Creates a notification rule in admin mode: every scope is accepted and channelIds/deviceSerialNumbers are not verified against userId.')
    .pipe(withRetirement);
const updateNotification = platform_1.HttpApiEndpoint.put('updateNotification') `/notifications`
    .setPayload(Notification.NotificationUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Update Notification (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Updates a notification rule. notificationId is required at runtime; ruleId is accepted as an alias. The repository upserts, so an unknown id returns 200 and creates a new rule.')
    .pipe(withRetirement);
const deleteNotification = platform_1.HttpApiEndpoint.del('deleteNotification') `/notifications`
    .setPayload(Notification.NotificationDeletePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete Notification (GREG)')
    .annotate(platform_1.OpenApi.Description, 'Deletes a notification rule. After ruleId→notificationId aliasing, only notificationId is validated. Returns 401 when the rule belongs to another user.')
    .pipe(withRetirement);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.greg')
    .add(updateAccount)
    .add(patchAccount)
    .add(getRegistry)
    .add(deleteRegistry)
    .add(listRegistry)
    .add(getLatestData)
    .add(getDeviceMetadata)
    .add(addDeviceMetadata)
    .add(removeDeviceMetadata)
    .add(listChannels)
    .add(deleteChannel)
    .add(createMobileChannel)
    .add(updateMobileChannel)
    .add(createEmailChannel)
    .add(updateEmailChannel)
    .add(createSmsChannel)
    .add(updateSmsChannel)
    .add(listNotifications)
    .add(createNotification)
    .add(updateNotification)
    .add(deleteNotification)
    .prefix('/admin/greg')
    .annotate(platform_1.OpenApi.Title, 'GREG Integration')
    .annotate(platform_1.OpenApi.Description, 'Partner REG (GREG) admin endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map